import React from 'react';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Expertise from '../components/sections/Expertise';
import Projects from '../components/sections/Projects';
import Philosophy from '../components/sections/Philosophy';
import Contact from '../components/sections/Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Expertise />
      <Projects />
      <Philosophy />
      <Contact />
    </>
  );
};

export default Home;